



















































































import { ProfileAssociation } from "@/models";
import { Component, Prop, Vue } from "vue-property-decorator";
import ClientCompanySearch from "@/components/ClientCompanySearch.vue";
import EntryItem from "@/components/EntryItem.vue";
import { formatDateDDMMYYYY } from "@/utils/Date";
import ClientCompany from "@/models/Agents/Company";

export type CompanySelectEvent = {
  company: ClientCompany;
  profileAssociation: ProfileAssociation;
};

@Component({
  components: {
    ClientCompanySearch,
    EntryItem,
  },
})
export default class ProfilesAssociationByProductCompaniesTable extends Vue {
  @Prop({ default: () => [] })
  readonly profileAssociations!: ProfileAssociation[];

  get shownProfileAssociations(): ProfileAssociation[] {
    return this.profileAssociations.filter((el) => !el.ignored);
  }

  get ignoredAssociationsText(): string {
    const count = this.profileAssociations.filter((p) => p.ignored).length;
    if (count == 1) {
      return "1 azienda ignorata";
    } else {
      return count > 0
        ? `${count} aziende ignorate`
        : "Nessun'azienda ignorata";
    }
  }

  formatDate(date: string) {
    return formatDateDDMMYYYY(date);
  }

  onCompanySelected(
    company: ClientCompany,
    profileAssociation: ProfileAssociation
  ) {
    const event: CompanySelectEvent = { company, profileAssociation };
    this.$emit("company-selected", event);
  }

  onCompanySearch(association: ProfileAssociation) {
    this.$emit("company-search", association);
  }

  onIgnore(association: ProfileAssociation) {
    this.$emit("ignore", association);
  }

  onMatchAssociations() {
    this.$emit("match-companies");
  }

  onSearchCleared(association: ProfileAssociation) {
    this.$emit("search-cleared", association);
  }
}
